// extracted by mini-css-extract-plugin
export default {"imageLink":"imageLink-lakZClud"};